import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import { getAdminDetails } from "../../redux/actions/campaignActions";
import { DarkModeContext } from "../../context/darkModeContext";
import ProfilePic from "../../assets/images/dummy_profile.png";
import "./navbar.scss";

const Navbar = () => {
  const { dispatch: darkModeDispatch } = useContext(DarkModeContext);
  const dispatch = useDispatch();
  const adminView = useSelector((state) => state.adminView);
  const { adminDetails } = adminView;
  let token = localStorage.getItem("accessToken");
  const id = JSON.parse(localStorage.getItem("admin"))?.data?.id;

  

  useEffect(() => {
    if (token && id) {
      dispatch(getAdminDetails(token, id));
    }
  }, [dispatch, token, id]);

  // useEffect(() => {}, [user]);
  return (
    <div className="navbar">
      <div className="wrapper">
        <div className="search"></div>
        <div className="items">
          <div className="item">
            <DarkModeOutlinedIcon
              className="icon"
              onClick={() => darkModeDispatch({ type: "TOGGLE" })}
            />
          </div>

          <div className="item">
            <h3>{adminDetails?.data?.firstname}</h3>
          </div>

          <div className="item">
            <img
              src={
                adminDetails?.data?.profilePic == null
                  ? ProfilePic
                  : adminDetails.data.profilePic
              }
              alt=""
              className="avatar"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
